import Vue from 'vue';
import Vuex from 'vuex';
import global from './modules/global';
import login from './modules/login';
import controlCenter from './modules/controlCenter';
import dealer from './modules/dealer';
import field from './modules/field';
import languages from './modules/languages';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    filterModalOpen: false,
    selectedDealer: null,
    programBreadcrumb: null,
    activeNavigation: null,
    periods: null,
    appealable: false,
    activePeriod: null,
    defaultPeriod: null,
    activeNavTab: null,
    userType: 'Dealer',
    domainMessages: null,
    entityMessage: null,
    periodMessages: null,
    entityPeriodMessages: null,
    activeFilters: null,
    activeFormFilters: null,
    activeLookupFilters: null,
    activeMessagesFilters: null,
    activeSecurityCenterFilters: null,
    appealInfo: null,
    selectedForm: null,
    selectedCCForm: null,
    otherAppealInfo: null,
    surveyInterference: null,
    surveyPermission: null,
  },
  mutations: {},
  actions: {},
  modules: { global, login, controlCenter, field, dealer, languages },
});
